import { usePeriod } from '@/app/context/PeriodContext';
import {
  useFindAllGroupedByDebitProjectQuery,
  useFindSingleCollaboratorProjectQuery,
} from '@/app/services/SharingDetails';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Typography, useTheme } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

function SharingDetailBreadcrumb() {
  const { code, codeCollaborator } = useParams();
  const period = usePeriod();

  const page = 0;
  const size = 10;

  const { data: sharingDetailsDebitProject } = useFindAllGroupedByDebitProjectQuery(
    {
      data: period.selectedPeriod?.date as string,
      searchTerm: code || '',
      page,
      size,
    },
    {
      skip: !period.selectedPeriod?.date,
    },
  );

  const { data: sharingSingleCollaboratorProject } = useFindSingleCollaboratorProjectQuery(
    {
      data: period.selectedPeriod?.date as string,
      badge: code as string,
      code: (codeCollaborator as string) || '',
    },
    {
      skip: !period.selectedPeriod?.date || !code || !codeCollaborator,
    },
  );

  const { t } = useTranslation(['sharingDetails', 'common']);
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box>
        {code ? (
          <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
            <Typography
              sx={{
                fontWeight: 'bold',
                fontSize: 18,
                color: '#F97C06',
                cursor: 'pointer',
                textAlign: 'center',
                mt: 4,
              }}
              onClick={() => navigate('/sharingDetail')}
            >
              {t('common:sharing.detail')}
            </Typography>

            <ArrowForwardIosIcon
              sx={{
                color: grey[600],
                height: theme.spacing(1.2),
                width: theme.spacing(1.2),
                mx: 1,
                mt: 4,
              }}
            />
            <Typography
              sx={{
                fontWeight: codeCollaborator ? 'bold' : 'normal',
                cursor: codeCollaborator ? 'pointer' : 'default',
                textAlign: 'center',
                mt: 4,
              }}
              onClick={() => codeCollaborator && navigate(`/sharingDetail/${code}`)}
            >
              {sharingDetailsDebitProject?.content[0].debitProjectCode}
            </Typography>
            {codeCollaborator && (
              <>
                <ArrowForwardIosIcon
                  sx={{
                    color: grey[600],
                    height: theme.spacing(1.2),
                    width: theme.spacing(1.2),
                    mx: 1,
                    mt: 4,
                  }}
                />
                <Typography
                  sx={{ textAlign: 'center', mt: 4 }}
                >{`${sharingSingleCollaboratorProject?.badge} - ${sharingSingleCollaboratorProject?.name}`}</Typography>
              </>
            )}
          </Box>
        ) : (
          <Box sx={{ mb: 0 }}>
            <Box sx={{ mt: 4, fontSize: 18, fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
              <Box>{t('common:sharing.detail')}</Box>
              <Box sx={{ color: '#888888', fontSize: 13, fontWeight: 'normal', lineHeight: '16px', ml: 1 }}>
                {t('calculation.memory')}
              </Box>
            </Box>
            <Typography sx={{ color: '#AAAAAA', fontSize: 13, mt: 1 }}>{t('feature.explanation')}</Typography>
          </Box>
        )}
      </Box>

      <Outlet />
    </Box>
  );
}

export default SharingDetailBreadcrumb;
